if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.knowMoreText = this.querySelector('.know-more-text');
        if(this.knowMoreText){
          this.addEventListener('click', (event) => {
            if (event.target.closest('.know-more-text')) {
              this.navigateToProductDescription();
            }
          });
        }

        this.mainProduct = document.getElementById('custom-main-product');
        this.customBuyButtonsContainer = this.querySelector('.custom-buy-buttons-container');
        
        if (this.customBuyButtonsContainer && this.mainProduct) {
          const onScroll = () => {
            if (window.innerWidth > 767) {
              this.customBuyButtonsContainer.classList.remove('show-buttons');
              return;
            }

            const rect = this.mainProduct.getBoundingClientRect();

            if (rect.top <= 0) {
              this.customBuyButtonsContainer.classList.add('show-buttons');
            } else {
              this.customBuyButtonsContainer.classList.remove('show-buttons');
            }
          };

          window.addEventListener('scroll', onScroll);
          window.addEventListener('resize', onScroll);
        }


        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      navigateToProductDescription() {
        const productDescription = this.querySelector('.product__accordion details');

        if (!productDescription) return;

        productDescription.open = true;
        requestAnimationFrame(() => {
          productDescription.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        });
      }
    }
  );
}
// Coupon Carousel (image-based with auto-scroll)
(function () {
  function initCouponCarousel(carousel) {
    const track = carousel.querySelector('.pdp-coupon-carousel__track');
    const dots = carousel.querySelectorAll('.pdp-coupon-carousel__dot');
    const slides = carousel.querySelectorAll('.pdp-coupon-carousel__slide');
    const total = slides.length;
    if (total <= 1) return;

    let current = 0;
    let autoScrollTimer = null;

    function goTo(index) {
      current = (index + total) % total;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
    }

    // Dot click
    dots.forEach((dot, i) => dot.addEventListener('click', () => {
      goTo(i);
      resetAutoScroll();
    }));

    // Touch / swipe support
    let startX = 0;
    track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', (e) => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? current + 1 : current - 1);
        resetAutoScroll();
      }
    }, { passive: true });

    // Auto-scroll
    const autoScrollEnabled = carousel.dataset.autoscroll === 'true';
    const interval = parseInt(carousel.dataset.interval, 10) || 4000;

    function startAutoScroll() {
      if (!autoScrollEnabled) return;
      autoScrollTimer = setInterval(() => goTo(current + 1), interval);
    }

    function resetAutoScroll() {
      if (!autoScrollEnabled) return;
      clearInterval(autoScrollTimer);
      startAutoScroll();
    }

    startAutoScroll();
  }

  function initAll() {
    document.querySelectorAll('.pdp-coupon-carousel').forEach(initCouponCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();